"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _LayoutPagingTable = _interopRequireDefault(require("01_core/components/layout/LayoutPagingTable"));
var _SearchCondition = _interopRequireDefault(require("01_core/components/layout/SearchCondition"));
var _TitleCard = _interopRequireDefault(require("01_core/components/layout/TitleCard"));
var _CButton = _interopRequireDefault(require("01_core/components/materials/CButton"));
var _CLabel = _interopRequireDefault(require("01_core/components/materials/CLabel"));
var _CSelect = _interopRequireDefault(require("01_core/components/materials/CSelect"));
var _DocumentLink = _interopRequireDefault(require("01_core/components/select/DocumentLink"));
var _DocumentUploadDelete = _interopRequireDefault(require("01_core/components/select/DocumentUploadDelete"));
var _SelectKaishaSoshiki = _interopRequireDefault(require("01_core/components/select/SelectKaishaSoshiki"));
var _CallAPI = require("01_core/components/system/CallAPI");
var _CodeUtil = require("01_core/components/system/CodeUtil");
var _CustomRouter = require("01_core/components/system/CustomRouter");
var _APIs = require("01_core/constants/APIs");
var _CodeConsts = require("01_core/constants/CodeConsts");
var _labelConsts = require("01_core/constants/labelConsts");
var _stringConsts = require("01_core/constants/stringConsts");
var _stringUtil = _interopRequireDefault(require("01_core/logics/stringUtil"));
var _windowUtil = _interopRequireDefault(require("01_core/logics/windowUtil"));
var _coreInfoBarActions = require("01_core/reducers/coreInfoBarActions");
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _reactRedux = require("react-redux");
var _material = require("@mui/material");
var _styles = require("@mui/material/styles");
var _activationReviewNaturalDisasterActions = require("./activationReviewNaturalDisasterActions");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const LINK_CELL_WIDTH = 150;
const ICON_CELL_WIDTH = 5;
const StyledTableRow = (0, _styles.styled)(_material.TableRow)(_ref => {
  let {
    theme
  } = _ref;
  return {
    '& td': {
      padding: 0
    }
  };
});
const LinkCell = (0, _styles.styled)(_material.TableCell)(_ref2 => {
  let {
    theme
  } = _ref2;
  return {
    width: LINK_CELL_WIDTH
  };
});
const IconCell = (0, _styles.styled)(_material.TableCell)(_ref3 => {
  let {
    theme
  } = _ref3;
  return {
    width: ICON_CELL_WIDTH
  };
});

/**
 * ドキュメント管理（発動後レビュー、自然災害）
 */
class ActivationReviewNaturalDisaster extends _react.default.Component {
  constructor(props) {
    super(props);
    // 検索処理
    _defineProperty(this, "onSearchClick", () => {
      const {
        intl,
        callAPI,
        openInfoBar,
        searchConditions,
        setSearchResult,
        selectSiteKindCd,
        isNewWindow
      } = this.props;
      let targetApi = '';
      if (_CodeConsts.CODE.SITE_KIND_CD.CODE_RH === selectSiteKindCd) {
        targetApi = _APIs.BCM_ACTIVATION_REVIEW_SEARCH;
      } else {
        targetApi = _APIs.BCM_NATURAL_DISASTER_SEARCH;
      }
      // 検索に不要な項目を除去
      let sendData = _objectSpread({}, searchConditions);
      delete sendData['targetList'];
      delete sendData['kaishaSoshikiLabel'];
      callAPI(targetApi, sendData).then(response => {
        if (response.status === _APIs.STATUS.SUCCESS) {
          setSearchResult(response.data);
          if (response.data.rowList.length === 0) {
            openInfoBar(_coreInfoBarActions.INFOBAR_VARIANT.INFO, intl.formatMessage({
              id: _labelConsts.LABEL.CORE_NO_SEARCH_RESULT_MESSAGE
            }));
          } else {
            _windowUtil.default.scrollBelowElement(this.area, isNewWindow);
          }
        }
      });
    });
    // 検索条件変更時
    _defineProperty(this, "onChangeCondition", key => {
      return value => {
        this.props.changeSearchCondition(key, value);
      };
    });
    // ドキュメントアップロード／削除実行時
    _defineProperty(this, "onDocumentUploadDelete", (documentObj, targetData, documentKindCd) => {
      const {
        searchResult,
        documentUploadDelete
      } = this.props;
      documentUploadDelete(searchResult, documentObj, targetData, documentKindCd);
    });
    // 詳細表示切り替え時
    _defineProperty(this, "onShowDetail", value => {
      const {
        changeShowDetail,
        searchResult
      } = this.props;
      changeShowDetail(value, searchResult);
    });
    // 一覧ヘッダー生成
    _defineProperty(this, "createHeader", () => {
      const {
        intl,
        searchResult,
        selectSiteKindCd
      } = this.props;
      let columns = [{
        dataKey: 'kaishaSoshiki',
        label: intl.formatMessage({
          id: _labelConsts.LABEL.CORE_KAISHA_SOSHIKI
        }),
        width: 100
      }, {
        dataKey: 'bcpTgtJigyo',
        label: intl.formatMessage({
          id: _labelConsts.LABEL.CORE_BCP_TGT_JIGYO
        }),
        width: 100
      }];
      if (_CodeConsts.CODE.SITE_KIND_CD.CODE_RH === selectSiteKindCd) {
        // 発動後レビューの場合、実施時期を会社／組織の前に追加
        let addColumns = {
          dataKey: 'exercisesNm',
          label: intl.formatMessage({
            id: _labelConsts.LABEL.CORE_IMPLEMENTATION_PERIOD
          }),
          width: 100
        };
        columns.unshift(addColumns);
      }
      searchResult.headerList.forEach(headerInfo => {
        let addInfo = {
          dataKey: headerInfo.documentKindCd,
          label: headerInfo.documentKindNmTh,
          width: 120
        };
        columns.push(addInfo);
      });
      return columns;
    });
    if (_CodeConsts.CODE.SITE_KIND_CD.CODE_RH === props.selectSiteKindCd) {
      props.callAPI(_APIs.BCM_SITE_KIND_INFO).then(response => {
        if (response.status === _APIs.STATUS.SUCCESS) {
          let targetList = [];
          response.data.forEach(target => {
            targetList.push({
              value: target.targetCd,
              displayName: target.exercisesNm
            });
          });
          if (targetList.length > 0) {
            props.changeSearchCondition('targetCd', targetList[0].value);
            props.changeSearchCondition('targetList', targetList);
          }
        }
      });
    }
  }
  componentDidMount() {
    window.scrollTo(0, 0);
  }
  render() {
    const {
      intl,
      searchConditions,
      paging,
      changePage,
      changeViewNum,
      searchResult,
      showDetail,
      selectSiteKindCd,
      isNewWindow
    } = this.props;

    // 検索条件
    const createConditions = () => {
      const conditions = [/*#__PURE__*/_react.default.createElement(_SelectKaishaSoshiki.default, {
        label: searchConditions.kaishaSoshikiLabel,
        bcmSelect: true,
        lv2limit: true,
        kaishaCd: searchConditions.kaishaCd,
        soshikiCd: searchConditions.soshikiCd,
        bcmKaishaSoshikiCd: searchConditions.bcmKaishaSoshikiCd,
        onChange: _ref4 => {
          let {
            kaishaCd,
            soshikiCd,
            bcmKaishaSoshikiCd,
            label
          } = _ref4;
          this.onChangeCondition('kaishaCd')(kaishaCd);
          this.onChangeCondition('soshikiCd')(soshikiCd);
          this.onChangeCondition('bcmKaishaSoshikiCd')(bcmKaishaSoshikiCd);
          this.onChangeCondition('kaishaSoshikiLabel')(label);
        },
        autoWidth: true
      }, intl.formatMessage({
        id: _labelConsts.LABEL.CORE_KAISHA_SOSHIKI_SELECT
      }))];
      if (_CodeConsts.CODE.SITE_KIND_CD.CODE_RH === selectSiteKindCd) {
        conditions.unshift(/*#__PURE__*/_react.default.createElement(_CLabel.default, {
          label: intl.formatMessage({
            id: _labelConsts.LABEL.CORE_IMPLEMENTATION_PERIOD
          })
        }, /*#__PURE__*/_react.default.createElement(_CSelect.default, {
          value: searchConditions.targetCd,
          onChange: this.onChangeCondition('targetCd'),
          items: searchConditions.targetList
        })));
      }
      return conditions;
    };

    // 検索結果の行データ作成
    const createRow = data => {
      let resultRow = {};
      if (_CodeConsts.CODE.SITE_KIND_CD.CODE_RH === selectSiteKindCd) {
        // 発動後レビューの場合、実施時期を追加
        resultRow['exercisesNm'] = _stringUtil.default.emptyToHyphen(data.exercisesNm);
      }
      resultRow['kaishaSoshiki'] = _stringUtil.default.emptyToHyphen(data.bcmKaishaSoshikiRk);
      resultRow['bcpTgtJigyo'] = _stringUtil.default.emptyToHyphen(data.bcpTgtJigyoNm);
      data.documentFileInfoList.forEach(documentInfo => {
        let targetDoc = searchResult.headerList.filter(target => {
          return target.documentKindCd === documentInfo.documentKindCd;
        });
        resultRow[documentInfo.documentKindCd] = /*#__PURE__*/_react.default.createElement(_material.Table, null, /*#__PURE__*/_react.default.createElement(_material.TableBody, null, /*#__PURE__*/_react.default.createElement(StyledTableRow, null, /*#__PURE__*/_react.default.createElement(LinkCell, null, documentInfo.fileNm ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_DocumentLink.default, {
          dispFileNm: documentInfo.fileNm,
          fileNm: documentInfo.fileNm,
          siteKindCd: selectSiteKindCd,
          targetCd: data.targetCd,
          bcmKaishaSoshikiCd: data.bcmKaishaSoshikiCd,
          bcpTgtJigyoCd: data.bcpTgtJigyoCd,
          documentKindCd: documentInfo.documentKindCd
        }), showDetail && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_material.Typography, {
          variant: "body2"
        }, documentInfo.note), /*#__PURE__*/_react.default.createElement(_material.Typography, {
          variant: "body2"
        }, documentInfo.updDt))) : _stringConsts.STRING_CONSTS.HYPHEN_ZENKAKU), /*#__PURE__*/_react.default.createElement(IconCell, null, /*#__PURE__*/_react.default.createElement(_DocumentUploadDelete.default, {
          isButton: false,
          siteKindCd: selectSiteKindCd,
          targetCd: data.targetCd,
          bcmKaishaSoshikiCd: data.bcmKaishaSoshikiCd,
          bcpTgtJigyoCd: data.bcpTgtJigyoCd,
          documentKindCd: documentInfo.documentKindCd,
          kaishaSoshikiNm: data.bcmKaishaSoshikiRk,
          bcpTgtJigyoNm: data.bcpTgtJigyoNm,
          documentKindNm: targetDoc[0].documentKindNm,
          implementationPeriod: data.exercisesNm,
          onChange: obj => {
            this.onDocumentUploadDelete(obj, data, documentInfo.documentKindCd);
          }
        })))));
      });
      return resultRow;
    };
    return /*#__PURE__*/_react.default.createElement(_TitleCard.default, {
      title: intl.formatMessage({
        id: selectSiteKindCd === _CodeConsts.CODE.SITE_KIND_CD.CODE_EQ ? _labelConsts.LABEL.BCM_DOCUMENT_MNG_NATURAL_DISASTERS : _labelConsts.LABEL.BCM_DOCUMENT_MNG_AFTER_ACTIVATION_REVIEW
      })
    }, /*#__PURE__*/_react.default.createElement(_material.CardContent, null, /*#__PURE__*/_react.default.createElement("div", {
      ref: ref => this.area = ref
    }, /*#__PURE__*/_react.default.createElement(_SearchCondition.default, {
      conditions: createConditions(),
      onSearchClick: this.onSearchClick,
      cancelBtn: /*#__PURE__*/_react.default.createElement(_CButton.default, {
        autoWidth: true,
        negative: true,
        onClick: () => {
          window.close();
        }
      }, intl.formatMessage({
        id: _labelConsts.LABEL.CORE_CLOSE
      }))
    })), /*#__PURE__*/_react.default.createElement(_LayoutPagingTable.default, {
      headerHeight: 80,
      title: intl.formatMessage({
        id: _labelConsts.LABEL.CORE_SEARCH_RESULT_LIST
      }),
      rowData: searchResult.rowList,
      columns: this.createHeader(),
      createRow,
      paging,
      changeViewNum,
      changeCurrentPage: changePage,
      showAll: showDetail,
      changeShowAll: this.onShowDetail,
      showAllLabel: intl.formatMessage({
        id: _labelConsts.LABEL.BCM_DETAIL_VIEW
      }),
      putTypography: true,
      isNewWindow: isNewWindow
    })));
  }
}
const mapStateToProps = state => {
  return {
    selectSiteKindCd: state.activationReviewNaturalDisaster.selectSiteKindCd,
    searchConditions: state.activationReviewNaturalDisaster.searchConditions[state.activationReviewNaturalDisaster.selectSiteKindCd],
    searchResult: state.activationReviewNaturalDisaster.searchResult[state.activationReviewNaturalDisaster.selectSiteKindCd],
    showDetail: state.activationReviewNaturalDisaster.showDetail[state.activationReviewNaturalDisaster.selectSiteKindCd],
    paging: state.activationReviewNaturalDisaster.paging[state.activationReviewNaturalDisaster.selectSiteKindCd]
  };
};
const mapDispatchToProps = dispatch => {
  return {
    changeSearchCondition: (key, value) => dispatch(_activationReviewNaturalDisasterActions.activationReviewNaturalDisasterActions[_activationReviewNaturalDisasterActions.TYPES.CHANGE_SEARCH_CONDITION](key, value)),
    setSearchResult: resultList => dispatch(_activationReviewNaturalDisasterActions.activationReviewNaturalDisasterActions[_activationReviewNaturalDisasterActions.TYPES.SET_SEARCH_RESULT](resultList)),
    documentUploadDelete: (searchResult, documentObj, targetData, documentKindCd) => dispatch(_activationReviewNaturalDisasterActions.activationReviewNaturalDisasterActions[_activationReviewNaturalDisasterActions.TYPES.SET_DOCUMENT_UPLOAD_DELETE](searchResult, documentObj, targetData, documentKindCd)),
    changePage: currentPage => dispatch(_activationReviewNaturalDisasterActions.activationReviewNaturalDisasterActions[_activationReviewNaturalDisasterActions.TYPES.CHANGE_PAGE](currentPage)),
    changeViewNum: viewNum => dispatch(_activationReviewNaturalDisasterActions.activationReviewNaturalDisasterActions[_activationReviewNaturalDisasterActions.TYPES.CHANGE_VIEW_NUM](viewNum)),
    changeShowDetail: (showDetail, searchResult) => dispatch(_activationReviewNaturalDisasterActions.activationReviewNaturalDisasterActions[_activationReviewNaturalDisasterActions.TYPES.CHANGE_SHOW_DETAIL](showDetail, searchResult)),
    openInfoBar: (type, message) => dispatch(_coreInfoBarActions.coreInfoBarActions[_coreInfoBarActions.TYPES_INFO_BAR.OPEN](type, message))
  };
};
var _default = exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactIntl.injectIntl)((0, _CallAPI.withCallAPI)((0, _CustomRouter.withRouter)((0, _CodeUtil.withCodeUtil)(ActivationReviewNaturalDisaster)))));